/* eslint-disable @typescript-eslint/no-explicit-any */
import { Route as RouteDom, Switch, useRouteMatch } from 'react-router-dom';
import { PropsWithChildren, ReactNode } from 'react';
import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import { Route } from '@/routes/routes.type';
import SyntheticAnalysisPage from '@/pages/CRMPage/SearchQuestionnairePage/SyntheticAnalysisPage';
import IndividualAnalysisPage from '@/pages/CRMPage/SearchQuestionnairePage/IndividualAnalysisPage';

interface Props {
  route: Route;
  extra: ReactNode;
  basePath: string;
}

const SearchQuestionnaireDetailContentTabs: React.FC<
  PropsWithChildren<Props>
> = ({ route, children, extra, basePath }) => {
  const { quizId } = useRouteMatch<{ quizId: string }>().params;

  return (
    <DefaultRouteTabs
      route={route as any}
      baseKey={basePath}
      basePath={`/app/customers/crm/searchQuestionnaire/${quizId}`}
      extra={extra}
    >
      <Switch>
        <RouteDom
          exact
          path="/app/customers/crm/searchQuestionnaire/:quizId/general"
          component={() => <>{children}</>}
        />
        <RouteDom
          exact
          path="/app/customers/crm/searchQuestionnaire/:quizId/syntheticAnalysis"
          component={() => <SyntheticAnalysisPage />}
        />
        <RouteDom
          exact
          path="/app/customers/crm/searchQuestionnaire/:quizId/individualAnalysis"
          component={() => <IndividualAnalysisPage />}
        />
      </Switch>
    </DefaultRouteTabs>
  );
};

export default SearchQuestionnaireDetailContentTabs;
